import React from 'react';
import { Div, DivProps, P } from '@kizi/core-components';
import { Timeline, TimelineItemProps } from '@kizi/shared-components';

export interface AfterTheSwitchProps extends DivProps {
  title: string;
  subtitle?: string;
  steps: TimelineItemProps[];
}

export const AfterTheSwitch: React.FC<AfterTheSwitchProps> = ({
  title,
  subtitle,
  steps,
  ...restProps
}) => {
  return (
    <Div {...restProps}>
      {title && (
        <P mb={3} variant="bodyImportant">
          {title}
        </P>
      )}
      {subtitle && (
        <P mb={3} variant="footnoteRegular">
          {subtitle}
        </P>
      )}
      <Timeline items={steps} />
    </Div>
  );
};
